import { AllIcons } from 'shared/ui/app-icon/types'

export type KyrgyzstanBookingStatus =
  | 'payment_pending_confirmation'
  | 'confirmed'
  | 'cancelled'
  | 'refund_pending'
  | 'refunded'
  | 'refund_rejected'

export interface KyrgyzstanBookingStatusInfo {
  arriveDate?: string
  outDate?: string
}

interface BookingStatusConfigItem {
  translationKey: string
  theme: 'pending' | 'success' | 'danger'
  background: string
  color: string
}

export interface BookingStatusDialogItem {
  icon: AllIcons
  translationKey: string
  withDates?: boolean
}

export const bookingStatusConfig: Record<
  KyrgyzstanBookingStatus,
  BookingStatusConfigItem
> = {
  payment_pending_confirmation: {
    translationKey: 'kyrgyzstan_block.booking_card.status.pending',
    theme: 'pending',
    background: 'var(--transparent-coral)',
    color: 'var(--coral)',
  },
  confirmed: {
    translationKey: 'kyrgyzstan_block.booking_card.status.confirmed',
    theme: 'success',
    background: 'var(--palette-green)',
    color: 'var(--green)',
  },
  cancelled: {
    translationKey: 'kyrgyzstan_block.booking_card.status.cancelled',
    theme: 'danger',
    background: 'var(--palette-red)',
    color: 'var(--red)',
  },
  refund_pending: {
    translationKey: 'kyrgyzstan_block.booking_card.status.refund_pending',
    theme: 'pending',
    background: 'var(--transparent-coral)',
    color: 'var(--coral)',
  },
  refunded: {
    translationKey: 'kyrgyzstan_block.booking_card.status.cancelled',
    theme: 'danger',
    background: 'var(--palette-red)',
    color: 'var(--red)',
  },
  refund_rejected: {
    translationKey: 'kyrgyzstan_block.booking_card.status.cancelled',
    theme: 'danger',
    background: 'var(--palette-red)',
    color: 'var(--red)',
  },
}

export const bookingStatusDialogItems: Record<
  KyrgyzstanBookingStatus,
  BookingStatusDialogItem[]
> = {
  payment_pending_confirmation: [
    {
      icon: AllIcons.TIME,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.pending.checking',
      withDates: true,
    },
    {
      icon: AllIcons.CALENDAR_NEW_FILLED,
      translationKey: 'kyrgyzstan_block.booking_card.status_popup.pending.wait',
    },
  ],
  confirmed: [
    {
      icon: AllIcons.PLANNER,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.confirmed.period',
      withDates: true,
    },
    {
      icon: AllIcons.MONEY_FILLED,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.confirmed.payment',
    },
    {
      icon: AllIcons.FILE_WORD_FILLED,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.confirmed.voucher',
    },
    {
      icon: AllIcons.ID_CARD,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.confirmed.identity',
    },
  ],
  cancelled: [
    {
      icon: AllIcons.CROSS,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.title',
    },
    {
      icon: AllIcons.MONEY_DOWN,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.refund',
    },
    {
      icon: AllIcons.HEADSET,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.support',
    },
  ],
  refund_pending: [
    {
      icon: AllIcons.TIME,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.refund_pending.processing',
    },
  ],
  refunded: [
    {
      icon: AllIcons.CROSS,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.title',
    },
    {
      icon: AllIcons.MONEY_DOWN,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.refund',
    },
    {
      icon: AllIcons.HEADSET,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.support',
    },
  ],
  refund_rejected: [
    {
      icon: AllIcons.CROSS,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.title',
    },
    {
      icon: AllIcons.MONEY_DOWN,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.refund',
    },
    {
      icon: AllIcons.HEADSET,
      translationKey:
        'kyrgyzstan_block.booking_card.status_popup.cancelled.support',
    },
  ],
}

export const CancellableStatuses: readonly KyrgyzstanBookingStatus[] = [
  'payment_pending_confirmation',
  'confirmed',
] as const

export const isBookingCancellable = (
  status?: KyrgyzstanBookingStatus | null,
): boolean => {
  if (!status) return false
  return CancellableStatuses.includes(status)
}
